import { render, staticRenderFns } from "./commonEvaluationStatisticList.vue?vue&type=template&id=22ec5711&scoped=true"
import script from "./commonEvaluationStatisticList.vue?vue&type=script&lang=js"
export * from "./commonEvaluationStatisticList.vue?vue&type=script&lang=js"
import style0 from "./commonEvaluationStatisticList.vue?vue&type=style&index=0&id=22ec5711&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22ec5711",
  null
  
)

export default component.exports